import React from 'react'
import './SelectionBox.css'

export default function SelectionBox({ isVisible, width, height, isSelected }) {
  const resizeHandlerSize = 4
  const resizeFillColor = isVisible ? '#888' : 'none'

  // use #resize hash in address bar to toggle resize handlers
  const showResizeHandlers = window.location.hash.includes('resize') && width > 20 && height > 20

  return (
    <svg
      aria-selected={isSelected}
      aria-hidden={true}
      className="SelectionBox"
      style={{
        position: 'absolute',
        width: width,
        height: height,
        zIndex: 1,
      }}
    >
      <g>
        <rect
          className="SelectionBox-rect"
          x={resizeHandlerSize / 2}
          y={resizeHandlerSize / 2}
          width={width - resizeHandlerSize}
          height={height - resizeHandlerSize}
          fillOpacity="0"
          stroke={isVisible ? '#bbb' : 'none'}
          strokeDasharray={'3, 3'}
          strokeWidth={1}
          strokeOpacity="1"
        />
        {showResizeHandlers && (
          <g>
            <rect
              className="SelectionBox-resize SelectionBox-resize-top-left"
              style={{ cursor: 'nwse-resize' }}
              x={0}
              y={0}
              fill={resizeFillColor}
              width={resizeHandlerSize}
              height={resizeHandlerSize}
            />
            <rect
              className="SelectionBox-resize SelectionBox-resize-top-right"
              style={{ cursor: 'nesw-resize' }}
              x={width - resizeHandlerSize}
              y={0}
              fill={resizeFillColor}
              width={resizeHandlerSize}
              height={resizeHandlerSize}
            />
            <rect
              className="SelectionBox-resize SelectionBox-resize-bottom-right"
              style={{ cursor: 'nwse-resize' }}
              x={width - resizeHandlerSize}
              y={height - resizeHandlerSize}
              fill={resizeFillColor}
              width={resizeHandlerSize}
              height={resizeHandlerSize}
            />
            <rect
              className="SelectionBox-resize SelectionBox-resize-bottom-left"
              style={{ cursor: 'nesw-resize' }}
              x={0}
              y={height - resizeHandlerSize}
              fill={resizeFillColor}
              width={resizeHandlerSize}
              height={resizeHandlerSize}
            />
          </g>
        )}
      </g>
    </svg>
  )
}
